/**
 * Predicate for an owned token
 * @param token
 */
export const owned = (token: { owned?: boolean }): boolean => Boolean(token.owned);
